import { useDispatch, useSelector } from "react-redux";
import { Paper, Grid, Typography, Box, Zoom, Button } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';

import { formatCurrency, getDisplayBalance, trim } from "../../helpers";
import { useEffect, useCallback, useMemo } from "react";
import { useWeb3Context } from "src/hooks/web3Context";
import "./home.scss";
import { Skeleton } from "@material-ui/lab";
import Logoimg from "../../assets/logo.png";
import smallLogoimg from "../../assets/small-icon.png";
import metamaskIcon from "../../assets/metamask.png";
import FooterLogo from "../../assets/footer-logo.webp"

import imgGroup1 from "../../assets/group/group-1.gif"
import imgGroup2 from "../../assets/group/group-2.gif"
import imgGroup3 from "../../assets/group/Group-3.png"
import imgGroup4 from "../../assets/group/group-4.gif"
import imgGroup5 from "../../assets/group/group-5.gif"

import image_api from "../../assets/nft-utility/api.png"
import image_give from "../../assets/nft-utility/give.png"
import image_gov from "../../assets/nft-utility/gov.png"
import image_launch from "../../assets/nft-utility/launch.png"

import AOS from "aos";
import "aos/dist/aos.css";


import Coin from "../../assets/dyno/coin.svg";
import { Link } from "react-router-dom";
import TimeCountdown from "src/components/TimeCountdown";
import img1_1 from "../../assets/dyno/1-1.png";
import img1_2 from "../../assets/dyno/1-2.png";
import img1_3 from "../../assets/dyno/1-3.png";
import img1_4 from "../../assets/dyno/1-4.png";
import CaiDan from "../../assets/dyno/tuozhuaicaidandaohang.png";
import { useState } from "react";
import { SvgIcon } from "@material-ui/core";
import { ReactComponent as GitHub } from "../../assets/icons/github.svg";
import { ReactComponent as Medium } from "../../assets/icons/medium.svg";
import { ReactComponent as Twitter } from "../../assets/icons/twitter.svg";
import { ReactComponent as Discord } from "../../assets/icons/discord.svg";
import medium from "../../assets/dyno/med@2x.png";
import { FixedFormat } from "@ethersproject/bignumber";
import styled from "styled-components";
import PdImg from "../../assets/dyno/veGAS.svg";
import WuImg from "../../assets/dyno/sGAS.svg";
import DiscordImg from "../../assets/dyno/discord.png";
import GuanImg from "../../assets/dyno/copy-2-3@3x.png";
import { shorten } from "../../helpers";
import { isPendingTxn, txnButtonText } from "src/slices/PendingTxnsSlice";
import { changeApproval, changeStake } from "../../slices/IdoThunk";
import UtilityItem from "src/components/UtilityItem/UtilityItem";
import GroupItem from "src/components/GroupItem/GroupItem";

import { addNetwork } from "src/hooks/hook";

function Home() {
  const { provider, address, connected, connect, chainID, disconnect } =
    useWeb3Context();
  const [menu, setmenu] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [isConnected, setConnected] = useState(connected);
  const [anchorEl, setAnchorEl] = useState(null);
  const [delayShow, setDelayShow] = useState(false);

  const stakedTotal = useSelector((state) => {
    // console.error(state.app?.circVal)

    return state?.app?.circVal
      ? getDisplayBalance(state?.app?.circVal, 9)
      : null;
  });
  const pendingTransactions = useSelector((state) => {
    return state.pendingTransactions;
  });

  const treasuryMarketValue = useSelector((state) => {
    return state.app.treasuryMarketValue;
  });
  let buttonText = "Connect Wallet";
  let clickFunc = connect;

  const onComplete = useCallback(() => {
    setDelayShow(true);
  }, []);
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  if (isConnected) {
    buttonText = shorten(address);
    clickFunc = disconnect;
  }

  if (pendingTransactions && pendingTransactions.length > 0) {
    buttonText = "In progress";
    clickFunc = handleClick;
  }

  const open = Boolean(anchorEl);
  const id = open ? "ohm-popper-pending" : undefined;

  const primaryColor = "#ffe300";
  const buttonStyles =
    "pending-txn-container" +
    (isHovering && pendingTransactions.length > 0 ? " hovered-button" : "");

  const idoBalance = useSelector((state) => {
    if (state.account.ido) {
      return state.account.ido.idoBalance;
    }
    return null;
  });
  const busdAmount = useSelector((state) => {
    if (state.account.ido) {
      return state.account.ido.busdAmount;
    }
    return null;
  });

  const isPay = useSelector((state) => {
    if (state.account.ido) {
      return state.account.ido.isPay;
    }
    return null;
  });

  const openStartTimes = useMemo(() => {
    return 1636113600000;
    // return Date.now() + 5000
  }, []);

  const isOpen = useMemo(() => {
    return Date.now() > openStartTimes;
  }, [delayShow, openStartTimes]);
  const stakingAPY = useSelector((state) => {
    return state.app.stakingAPY;
  });

  const openIsPayTime = useMemo(() => {
    return Date.now() < 1636113600000 + 86400000;
  }, []);
  const openOverTimes = useMemo(() => {
    return 1636372800000;
  }, [isOpen]);
  const isOver = useMemo(() => {
    return Date.now() > openOverTimes;
  }, [Date.now(), openOverTimes]);

  useEffect(() => {
    AOS.init({duration: 1200});
    AOS.refresh();
  }, []);

  useEffect(() => {
    if (address) {
      connect();
    }
  }, [address]);
  useEffect(() => {
    if (pendingTransactions.length === 0) {
      setAnchorEl(null);
    }
  }, [pendingTransactions]);

  useEffect(() => {
    setConnected(connected);
  }, [connected]);

  const ShowhideClick = () => {
    setmenu(!menu);
  };
  //支付弹窗
  const [Popup, setPopup] = useState(false);
  const PopupClick = () => {
    let timeId = null;
    if (isPay === true) {
      setPopup(false);
      return;
    }
    if (isConnected) {
      setPopup(!Popup);
    } else {
      clickFunc();
    }
  };


  const nftUtility = [
    {image:image_api,     title:"Boosted APY",            description:"All NFT holders will get exclusive boosted APY on their assets based on its rarity"},
    {image:image_give,    title:"Airdrops & Giveaways",   description:"HX NFT Holders will be rewarded consistently with community airdrops & giveaways"},
    {image:image_launch,  title:"Launchpad Access",       description:"NFT holders are first in line to all the innovative projects that will launch in HX DAO launchpad"},
    {image:image_gov,     title:"HXDAO Governance",     description:"Holders are able to participate in our governance program to make key decisions in the decentralized ecosystem"},
  ];

  const groupItems = [
    {image:imgGroup3, title:"LP Fees & Bonds",  description:"Liquidity Pool fees as well as Bond sales increase HX’s treasury revenue. They also lock in liquidity and help to control the {} supply."},
    {image:imgGroup4, title:"HXDAO Treasury", description:"Treasury inflow is increasing the Treasury Balance and backs outstanding {} tokens and regulates staking APY."},
    {image:imgGroup5, title:"Staking Rewards",  description:"Compounds yields automatically through a treasury backed token with intrinsic value."},
  ];


  return (
    <div className="home_gd">
      <div className="headBox">
        <img src={smallLogoimg} alt="" className="logo" />

        {/* <Box className="logo-small" ><img src={smallLogoimg} alt="" className="logo" /></Box> */}
        <Box className="logo-default" ><img src={Logoimg} alt="" className="logo" /></Box>
        <ul className="uls">
          <li className="lis">
            <a className="a" href="/stake" target="_self">
              Stake
            </a>
          </li>
          <li className="lis">
            <a className="a" href="/bonds" target="_self">
              Bond
            </a>
          </li>
          <li className="lis">
            <a className="a" href="https://forum.dynochain.io" target="_blank">
              Forum
            </a>
          </li>
          <li className="lis">
            <a className="a" href="https://docs.hx.tech/" target="_blank">
              Documentation
            </a>
          </li>
        </ul>
        <div>
          <Button
            className={buttonStyles}
            variant="contained"
            color="secondary"
            size="large"
            style={
              pendingTransactions.length > 0 ? { color: primaryColor } : {}
            }
            onClick={clickFunc}
            onMouseOver={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            key={1}
          >
            {buttonText}
          </Button>
        </div>
        {/* 移动端顶部列表 */}
        <div className="CaiDanImgBox">
          <img
            src={CaiDan}
            alt=""
            onClick={() => ShowhideClick()}
            className="caidanimg"
          />
        </div>
      </div>
      <div>
        <div className="main-landing py-4vw">
          <div className="landing-anim">

          </div>
          <div className="d-flex align-center px-7w width-limit">
            <div className="main-contents p-50">
              <h1>{"Igniting Wealth with "}
                <em class="animated" stype={{color:"#BE123C"}}>HXDAO<svg className="nectar-scribble circle" viewBox="0 0 800 350" preserveAspectRatio="none"><path style={{animationDuration: "1.8s"}} transform="matrix(0.9791300296783447,0,0,0.9791300296783447,400,179)" stroke-linejoin="miter" fill-opacity="0" pathLength="1" stroke-miterlimit="4" stroke="#ffffff" stroke-opacity="1" stroke-width="20" d=" M253,-161 C253,-161 -284.78900146484375,-201.4600067138672 -376,-21 C-469,163 67.62300109863281,174.2100067138672 256,121 C564,34 250.82899475097656,-141.6929931640625 19.10700035095215,-116.93599700927734"></path></svg></em>
              </h1>
              <p style={{lineHeight:"30px"}}>(3,3) & grow your wealth with HXDAO. <br/>HOLD until you reach your goals</p>

              <div className="enter-box">
                <a href="/stake" className="btn btn-enter" target="_self">
                  Enter App
                </a>
                <a href="/stake" className="btn btn-green" target="_self">
                  Roadmap
                </a>
              </div>
            </div>
            <div className="symbol-image">
              <img className="w-70" src={imgGroup1} />
            </div>
          </div>
        </div>
        <div className="about-dynodao">
            <div className="d-flex align-center px-7w py-50 width-limit">
              <div className="symbol-image px-3w">
                <img className="w-70" src={imgGroup2} />
              </div>
              <div className="about-dao-contents">
                <h1>What is <span style={{color: "#af0202", fontStyle:"normal"}}>HXDAO</span>?</h1>
                <p style={{lineHeight:"30px", textAlign:"left"}}>HX is the decentralized EVM-compatible public blockchain that powers the HX platform and ecosystem. It is fully compatible with Ethereum meaning that any smart contract that can be deployed on the latter can also run on top of $BBC.</p>
                <div className="efficient d-flex space-between">
                  <div className="w-50">
                    <ul>
                      <li><CheckIcon style={{fontSize:"1rem"}}/><strong>Passive Income</strong></li>
                      <li><CheckIcon style={{fontSize:"1rem"}}/><strong>Asset Backed</strong></li>
                    </ul>
                  </div>
                  <div className="w-50">
                    <ul>
                      <li><CheckIcon style={{fontSize:"1rem"}}/><strong>Your funds are SAFE</strong></li>
                      <li><CheckIcon style={{fontSize:"1rem"}}/><strong>Transparency</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
              
            </div>

            <div className="px-7w py-50 width-limit">
              <h1 className="align-center" style={{fontSize:"60px"}}>
                <em className="animated">
                  <span style={{color: "#ffffff", fontStyle:"normal"}}>UTILITIES</span>
                  <svg className="nectar-scribble basic-underline" viewBox="-400 -55 730 60" preserveAspectRatio="none"><path data-aos="fade-up" style={{animationDuration: "1.3s"}} d="m -383.25 -6 c 55.25 -22 130.75 -33.5 293.25 -38 c 54.5 -0.5 195 -2.5 401 15" stroke="#f8cc82" pathLength="1" stroke-width="14" fill="none"></path></svg>
                </em>
              </h1>
              <div className="d-flex">
                {nftUtility.map((item)=>(
                  <UtilityItem image={item.image} title = {item.title} description = {item.description}/>
                )) }
              </div>
            </div>
        </div>
        <div className="how-work">
          <h1 className="group-title align-center" style={{color:"#ffffff"}}>{"How does "}
            <em className="animated">
              <span style={{color: "#af0202", fontStyle:"normal"}}>HXDAO</span>
              <svg className="nectar-scribble basic-underline" viewBox="-400 -55 730 60" preserveAspectRatio="none"><path style={{animationDuration: "1.3s"}} d="m -383.25 -6 c 55.25 -22 130.75 -33.5 293.25 -38 c 54.5 -0.5 195 -2.5 401 15" stroke="#ffffff" pathLength="1" stroke-width="14" fill="none"></path></svg>
            </em>
          {" work?"}</h1>
          <div className="width-limit">
            {groupItems.map((item, index)=>(
              <GroupItem image={item.image} title={item.title} description={item.description} type={index}/>
            ))}
          </div>
        </div>
        {/* <div className="nft-drop">
          <div className="p-50">
            <div className="nft-drop-contents py-50 px-20">
              <h1 className="group-title align-center" style={{color:"#58e765"}}>DynoDAO NFT drop coming soon!</h1>
              <p className="align-center">Join our discord to get whitelisted</p>
              <div className="d-flex align-center content-center">
                <a href="/stake" className="btn btn-green" target="_self">
                  Join Discord
                </a>
              </div>
            </div>
          </div>
        </div> */}
        <div className="brand">
          <div className="d-flex" style={{paddingBottom:"5%", alignItems:"center"}}>
          <Box
            sx={{width: { xs: '100%', md: '50%', lg:"68%" }}}
          >
            <Box
              className="get-start"
            >
              <h1 data-aos="fade-up" >Scale your brand and earn more revenue</h1>
              <div className="enter-box" data-aos="fade-up">
                <a href="#" className="btn btn-green" style={{display:"flex", alignItems:"center"}}>
                  Get Started
                </a>
              </div>
              
            </Box>
          </Box>
      
          <Box
            className="connct"
            sx={{width: { xs: '50%', md: '25%', lg:"16%" }}}
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <h2>Connect</h2>
            <a href="#"><h3>Testimonials</h3></a>
            <a href="#"><h3>Features</h3></a>
          </Box>

          <Box
            className="contacts"
            sx={{width: { xs: '50%', md: '25%', lg:"16%" }}}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h2>Contact Us</h2>
            <h3>+216 (0)40 3629 4753</h3>
            <h3>hello@domain.com</h3>
          </Box>
          </div>

          <Box
          >
            <Box className="enter-box" style={{justifyContent: "end"}} >
              <a href="#" className="btn btn-green add-network" onClick={(e)=>{addNetwork()}}>
                <img src={metamaskIcon} style={{width:"20px", marginRight:"2px"}}/>
                Add HX Network
              </a>
            </Box>

            <div 
              className="copy-right"
            >
              <p style={{margin:"0"}}>©  2023. HXDao all copyrights reserved.</p>
            </div>
          </Box>
        </div>

        
      </div>
      {/* 底部链接栏 */}
      {/* <div className="bottomBor a">
        <div className="bottomLogo">
          <img src={FooterLogo} className="bottomLogo"/>
        </div>
        <div className="socialLinks">
          <a
            href="https://twitter.com/HX_Network"
            target="_blank"
            className="bottomImgs a2"
          >
            <img src={img1_1} alt="" className="bottomImgs2" />
          </a>
          <a
            href="https://github.com/"
            target="_blank"
            className="bottomImgs a2"
          >
            <img src={img1_2} alt="" className="bottomImgs2" />
          </a>
          <a
            href="https://medium.com/@hxgas101"
            target="_blank"
            className="bottomImgs a2"
          >
            <img src={medium} alt="" className="bottomImgs2" />
          </a>
          <a href="https://t.me/hxchain" target="_blank" className="bottomImgs a">
            <img src={img1_4} alt="" className="bottomImgs2" />
          </a>
          <a href="https://discord.gg/WC5thfjRDt" target="_blank" className="bottomImgs a">
            <img src={DiscordImg} alt="" className="bottomImgs2" />
          </a>
        </div>
      </div> */}
      {menu ? (
        <div className="moban" onClick={() => ShowhideClick()}>
          <div className="CaiDanlieBiao">
            <img src={Logoimg} alt="" className="logo2" />
            <div className="lis2">
              <a className="a" href="/stake">
                Stake
              </a>
            </div>
            <div className="lis2">
              <a className="a" href="/bonds">
                Bond
              </a>
            </div>
            <div className="lis2">
              <a target="_blank" className="a" href="https://forum.dynochain.io">
                Forum
              </a>
            </div>
            <div className="lis2">
              <a target="_blank" className="a" href="https://docs.hx.tech/">
                Documentation
              </a>
            </div>
          </div>
        </div>
      ) : null}

      {/* 支付弹窗 */}

      {Popup ? (
        <div className="Max_Box">
          <div className="Min_Box">
            <div onClick={() => PopupClick()} className="close">
              <img src={GuanImg} alt="" width="14px" />
            </div>
            <PAYSTATUS
              isPay={isPay}
              openIsPayTime={openIsPayTime}
              isOpen={isOpen}
              busdAmount={busdAmount}
              idoBalance={idoBalance}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Home;

const PAYSTATUS = ({
  idoBalance,
  isPay,
  isOpen,
  busdAmount,
  openIsPayTime,
}) => {
  console.error({
    sss: isPay === true,
    isPay,
  });
  if (openIsPayTime === true) {
    return (
      <PadingBaiMingDan_Box
        title={
          "ITO whitelist updating, please stay tuned with notice in the telegram group"
        }
      />
    );
  }
  if (idoBalance === null || isOpen === null) {
    return <Pading_Box />;
  } else if (isOpen === false) {
    return <PadingBaiMingDan_Box title={""} />;
  } else if (isPay === true) {
    return <PadingBaiMingDan_Box title={"Purchased"} />;
  } else if (idoBalance > 0) {
    return <Inp_Box busdAmount={busdAmount} idoBalance={idoBalance} />;
  } else {
    return <PadingBaiMingDan_Box />;
  }
};
//输入框组件
function Inp_Box({ idoBalance, busdAmount }) {
  const { provider, address, connected, connect, chainID, disconnect } =
    useWeb3Context();
  const dispatch = useDispatch();

  const pendingTransactions = useSelector((state) => {
    return state.pendingTransactions;
  });

  const stakeAllowance = useSelector((state) => {
    return state.account.ido && state.account.ido.idoAllowance;
  });
  const hasAllowance = useCallback(() => {
    console.error(stakeAllowance > 0);
    return stakeAllowance > 0;
  }, [stakeAllowance]);
  const onSeekApproval = async (token) => {
    await dispatch(
      changeApproval({ address, token, provider, networkID: chainID })
    );
  };
  const onChangeStake = async (action) => {
    // eslint-disable-next-line no-restricted-globals
    await dispatch(
      changeStake({ address, action, provider, networkID: chainID })
    );
  };
  const onClick = () => {};
  return (
    <MinInp_Box>
      <div className="Content_Box1">
        <span>Your ITO Quota</span>
      </div>
      <div className="Content_Box2">
        <div>ITO Quota</div>
        <input
          type="text"
          placeholder={`${idoBalance}HX`}
          className="InpStyle"
        />
      </div>
      <div className="Content_Box2">
        <div>Purchase</div>
        <input
          type="text"
          placeholder={`${busdAmount}USDT`}
          disabled
          className="InpStyle"
        />
      </div>
      <div className="Content_Box3">
        DynoDAO project will launch on 12:00 8th July. 2022, you will be able to
        claim your HX token manually on the website.
      </div>

      {address && hasAllowance() ? (
        <div
          // onClick={onClick}
          disabled={isPendingTxn(pendingTransactions, "staking")}
          onClick={() => {
            onChangeStake("stake");
          }}
          className="Content_Box4"
        >
          {txnButtonText(pendingTransactions, "buy", "Purchase")}
        </div>
      ) : (
        <Button
          className="stake-button"
          variant="contained"
          color="primary"
          disabled={isPendingTxn(pendingTransactions, "approve_staking")}
          onClick={() => {
            onSeekApproval();
          }}
        >
          {txnButtonText(pendingTransactions, "approve", "Approve")}
        </Button>
      )}
    </MinInp_Box>
  );
}

const MinInp_Box = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`;

//判定等待组件
function Pading_Box() {
  return (
    <PadingBox>
      <PandingImg src={PdImg} />
      <PandingContent>Evaluating, please wait a moment～</PandingContent>
    </PadingBox>
  );
}
//判定白名单
function PadingBaiMingDan_Box({ title = "You are not on the whitelist" }) {
  return (
    <PadingBox>
      <PandingImg src={WuImg} />
      <PandingContent>{title}</PandingContent>
    </PadingBox>
  );
}
const PadingBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const PandingImg = styled.img`
  /* width: 100%; */
  max-width: 332px;
`;
const PandingContent = styled.div`
  color: #afb0b3;
  margin-top: 43px;
`;
